import React from "react";

interface PropertyCardProps {
  property: {
    id: number;
    slug?: string;
    city: string;
    state: string;
    country?: string;
    image?: string;
  };
  defaultImage: string;
}

const PropertyCard: React.FC<PropertyCardProps> = ({
  property,
  defaultImage,
}) => {
  // Format slug into a readable title
  const formatSlug = (slug: string) => {
    return slug
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const propertyTitle = property?.slug ? formatSlug(property.slug) : "Property";

  return (
    <div className="border-2 border-neutral-200 dark:border-neutral-700 rounded-2xl overflow-hidden bg-white dark:bg-neutral-800">
      <img
        src={property?.image || defaultImage}
        alt={propertyTitle}
        className="w-full h-48 object-cover"
        onError={(e) => {
          e.currentTarget.src = defaultImage;
        }}
      />
      <div className="p-4">
        {/* Property Title (from slug) */}
        <h4 className="text-lg font-semibold text-neutral-900 dark:text-white mb-2">
          {propertyTitle}
        </h4>

        {/* Location */}
        <p className="text-sm text-neutral-600 dark:text-neutral-400 flex items-center gap-1">
          <svg
            className="w-4 h-4 flex-shrink-0"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
          {property?.city}, {property?.state}
          {property?.country && `, ${property.country}`}
        </p>
      </div>
    </div>
  );
};

export default PropertyCard;
